import { ISnackbarService } from './ISnackbarService';
import { logger } from '@common/logging/logger';

export class SnackbarServiceExceptionDecorator implements ISnackbarService {
  private decoree: ISnackbarService;

  constructor(decoree: ISnackbarService) {
    this.decoree = decoree;
  }

  showMessage(message: string): void {
    try {
      this.decoree.showMessage(message);
    } catch (err) {
      this.logError('showMessage', err);
    }
  }

  private logError(methodName: string, error: unknown): void {
    logger.error(`SnackbarService.${methodName} failed:`, error);
  }
}
